var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.26 12.818H17.4431V10.9096H21.26V12.818ZM21.26 13.9085H17.4431V15.817H21.26V13.9085ZM21.26 4.91162H17.4431V6.82004H21.26V4.91162ZM21.26 7.91059H17.4431V9.81901H21.26V7.91059ZM21.26 16.9075H17.4431V18.816H21.26V16.9075ZM23.8964 20.6699C23.7873 21.237 23.1057 21.2506 22.6504 21.2697H14.1715V23.7234H12.4785L0 21.5423V2.46067L12.5521 0.276855H14.1715V2.44975H22.3587C22.8195 2.46882 23.3266 2.43611 23.7273 2.71145C24.0082 3.11495 23.9809 3.62753 24 4.09098L23.9891 18.2843C23.9755 19.0777 24.0627 19.8874 23.8964 20.6699ZM9.99745 16.3922C9.24502 14.8655 8.47894 13.3496 7.72917 11.8229C8.47073 10.337 9.20142 8.84575 9.92934 7.35442C9.31045 7.38442 8.69156 7.42257 8.07544 7.46621C7.61466 8.58671 7.07756 9.67726 6.7177 10.836C6.38236 9.7427 5.93798 8.69031 5.53177 7.62432C4.93195 7.65704 4.33214 7.69248 3.73238 7.72792C4.36486 9.12386 5.03831 10.5006 5.65172 11.9047C4.92923 13.2678 4.25311 14.6501 3.55242 16.0215C4.14947 16.046 4.74656 16.0705 5.34361 16.0787C5.76895 14.9936 6.29784 13.9494 6.66863 12.8425C7.00125 14.0312 7.56558 15.13 8.02908 16.2668C8.68613 16.3132 9.34041 16.3541 9.99745 16.3922ZM22.6997 3.74457H14.1715V4.91162H16.3526V6.82004H14.1715V7.91059H16.3526V9.81901H14.1715V10.9096H16.3526V12.818H14.1715V13.9085H16.3526V15.817H14.1715V16.9075H16.3526V18.816H14.1715V20.0768H22.6997V3.74457Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel_icon.1dd757047ac7fa56639afb289da2cf0e.svg";
export { ForwardRef as ReactComponent };